import {
  fetchCompositionDetail, 
  requestReWork, 
  requestCorrect, 
  requestAnswerQuestion,
   fetchCorrectTeachers,
    requestDistribute, 
    fetchAnswerRecords,
     fetchStatusCount, fetchRecordsCount,
  handleExportWpord,
  getLastApprovedInfo
} from '@/services/writing'
import { Loading } from 'element-ui'

export default {
  namespaced: true,
  state: {
    correctingTasks: [],
    compositionInfo: {},
    writingTeachers: [],
    correctAnswers: [],
    countInfo: {},
    recordsCountInfo: {},
    lastApprovedInfo: {}
  },
  actions: {
    async getCompositionDetail({ dispatch, commit }, payload) { // 批改详情
      const loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading'
      })
      const content = await fetchCompositionDetail(payload)
      loading.close()
      commit('UPDATE_VALUE_STATES', { key: 'compositionInfo', data: content })
    },
    async updateReWork({ dispatch, commit }, payload) { // 打回重写
      const { callback, ...rest } = payload
      await requestReWork(rest)
      typeof callback === 'function' && callback()
    },
    async updateCorrect({ dispatch, commit }, payload) { // 立即批改
      const { callback, ...rest } = payload
      await requestCorrect(rest)
      typeof callback === 'function' && callback()
    },
    async answerQuestion({ dispatch, commit }, payload) { // 答疑
      const { callback, ...rest } = payload
      await requestAnswerQuestion(rest)
      typeof callback === 'function' && callback()
    },
    async updateDistribute({ dispatch, commit }, payload) { // 分配
      const { callback, ...rest } = payload
      await requestDistribute(rest)
      typeof callback === 'function' && callback()
    },
    async getTeachers({ dispatch, commit }, payload) { // 写作批改老师列表
      console.log({payload})
      const content = await fetchCorrectTeachers(payload)
      commit('UPDATE_VALUE_STATES', { key: 'writingTeachers', data: content })
    },
    async getAnswerRecords({ dispatch, commit }, payload) {
      const content = await fetchAnswerRecords(payload)
      commit('UPDATE_VALUE_STATES', { key: 'correctAnswers', data: content })
    },
    async getStatusCount({ dispatch, commit }, payload) {
      const content = await fetchStatusCount(payload)
      commit('UPDATE_VALUE_STATES', { key: 'countInfo', data: content })
    },
    async getRecordsCount({ dispatch, commit }, payload) {
      const content = await fetchRecordsCount(payload)
      commit('UPDATE_VALUE_STATES', { key: 'recordsCountInfo', data: content })
    },
    async exportWprdDetail({ dispatch, commit }, payload) {
      const content = await handleExportWpord(payload)
      let link = document.createElement('a')
      link.href = content
      link.click()
    },
    async getLastApprovedInfo({ dispatch, commit }, payload) {
      const content = await getLastApprovedInfo(payload)
      commit('UPDATE_VALUE_STATES', { key: 'lastApprovedInfo', data: content })
    }
  },
  mutations: {
    UPDATE_VALUE_STATES(state, payload) {
      const { key, data } = payload
      state[key] = data
    }

  }

}



// WEBPACK FOOTER //
// ./src/store/modules/writing.js